import anime from 'animejs'
import { findOne, append, createElement, addClass, setAttr, removeClass, on } from 'chirashi'

const SVG_NS = 'http://www.w3.org/2000/svg'

const LOGO_TEXT = 'REVEAL'

export default class LogoManager {
  constructor(svg, isShown = true) {
    this.svg = svg
    setAttr(this.svg, { viewBox: `0 0 500 100` })

    // MASK
    const defs = document.createElementNS(SVG_NS, 'defs')
    const mask = document.createElementNS(SVG_NS, 'mask')
    mask.id = 'text-mask'

    const rectMask = document.createElementNS(SVG_NS, 'rect')
    setAttr(rectMask, {
      width: '100%',
      height: '100%',
      fill: '#FFFFFF',
    })

    this.textMask = document.createElementNS(SVG_NS, 'text')
    this.textMask.appendChild(document.createTextNode('REVEAL'))
    setAttr(this.textMask, {
      x: 240,
      y: 75,
      fill: '#000000',
      'font-size': 90,
      'letter-spacing': 3,
      'text-anchor': 'middle',
      border: '5 solid black',
    })

    mask.appendChild(rectMask)
    mask.appendChild(this.textMask)
    defs.appendChild(mask)
    append(this.svg, defs)

    // TEXT
    this.text = document.createElementNS(SVG_NS, 'text')
    this.text.appendChild(document.createTextNode('REVEAL'))
    setAttr(this.text, {
      x: isShown ? 250 : 240,
      y: 75,
      fill: '#FFFFFF',
      'font-size': 90,
      'letter-spacing': 3,
      'text-anchor': 'middle',
      mask: 'url(#text-mask)'
    })

    append(this.svg, this.text)
  }

  show(callback = () => {}) {
    anime({
      targets: this.text,
      x: 250,
      duration: 1500,
      easing: 'easeOutQuad',
      complete: callback
    })
  }

  hide(callback = () => {}) {
    anime({
      targets: this.textMask,
      x: 250,
      duration: 1500,
      easing: 'easeInQuad',
      complete: () => {
        setTimeout(() => {
          setAttr(this.svg, { opacity: 0 })
          callback()
        }, 1000)
      }
    })
  }
}


// WEBPACK FOOTER //
// ./components/UI/LogoManager.js